import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

// 🌟 3つの地域専用のファイルをそれぞれインポートします
import NumazuKaishuuView from '../views/NumazuKaishuuView.vue'
import MishimaKaishuuView from '../views/MishimaKaishuuView.vue'
import NagaizumiKaishuuView from '../views/NagaizumiKaishuuView.vue'
import IzuKaishuuView from '../views/IzuKaishuuView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  
  // 🌟 沼津市専用ルート
  {
    path: '/t-kaishuu/numazu',
    name: 'kaishuu-numazu',
    component: NumazuKaishuuView
  },
  // 🌟 三島市専用ルート
  {
    path: '/t-kaishuu/mishima',
    name: 'kaishuu-mishima',
    component: MishimaKaishuuView
  },
  // 🌟 長泉町専用ルート
  {
    path: '/t-kaishuu/nagaizumi',
    name: 'kaishuu-nagaizumi',
    component: NagaizumiKaishuuView
  },
  // 🌟 伊豆専用ルート
  {
    path: '/t-kaishuu/izu',
    name: 'kaishuu-izu',
    component: IzuKaishuuView
  },
  
  // 互換性・エラー対策：古いURLや変なURLが来たら沼津に飛ばす
  {
    path: '/t-kaishuu/:area',
    redirect: '/t-kaishuu/numazu'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: routes
})

export default router
